import CryptoJS from 'crypto-js';

// generate the HMAC-SHA256 hash.
export function hmacSha256Hex(secret, message) {
    return CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(secret, message));
}
